module.exports = __webpack_public_path__ + "static/media/home_grid_item_2.bde3ccc0.png";